import clsx from "clsx";
import { ForwardRefRenderFunction, forwardRef, useId } from "react";

import DangerouslySetCMSMarkup from "@ui/components/article/DangerouslySetCMSMarkup";
import * as styles from "@ui/components/navigation/LoopNav/LoopNav.css";
import { LoopNavSectionProps } from "@ui/components/navigation/LoopNav/loopNav.types";
import { sharedStyles } from "@ui/shared-styles";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

import LoopNavSectionTitle from "./LoopNavSectionTitle";

type Props = LoopNavSectionProps & { loopNavTitle: string };

const LoopNavSection: ForwardRefRenderFunction<HTMLLIElement, Props> = (
  { text: title, items, onClick, open = false, permalink, loopNavTitle },
  ref,
) => {
  const sectionId = useId();

  const analytics = useAnalytics();

  return (
    <li
      className={
        open && items ? styles.sectionListItemOpen : styles.sectionListItem
      }
    >
      <LoopNavSectionTitle
        open={open}
        {...((items?.length || 0) === 0 ? { permalink } : {})}
        onClick={onClick}
        text={title}
        sectionId={sectionId}
        loopNavTitle={loopNavTitle}
      />
      {items && (
        <ol
          className={clsx(
            !open && sharedStyles.layout.hide,
            styles.sectionList,
          )}
          id={sectionId}
        >
          {items.map(({ text: title, permalink, current }) => {
            return (
              <li
                key={title}
                {...(current ? { ref } : {})}
                className={clsx(
                  styles.navItem,
                  current && styles.navItemCurrent,
                )}
              >
                {permalink ? (
                  <a
                    onClick={() => {
                      analytics?.emit({
                        event: "loopnav",
                        loopnav: {
                          action: "click",
                          loopnav_name: loopNavTitle,
                          url: permalink,
                          variant: "dropdown",
                        },
                      });
                    }}
                    className={styles.navItemText}
                    href={permalink}
                  >
                    <DangerouslySetCMSMarkup component="span" html={title} />
                  </a>
                ) : (
                  <DangerouslySetCMSMarkup
                    className={styles.navItemText}
                    component="span"
                    html={title}
                  />
                )}
              </li>
            );
          })}
        </ol>
      )}
      <hr className={styles.sectionDivider} />
    </li>
  );
};

export default forwardRef<HTMLLIElement, Props>(LoopNavSection);
